import React from "react";

interface CheckboxGlyphStylesProps {
  borderColor: string;
}

const selector = ".Checkbox-styled-input";

/**
 * Component that injects styles for the checkbox box/glyph element. This
 * is not targetable via component model styles so the configured styles
 * are added as raw CSS in style tags. !important not required since
 * we aren't exposing the checkbox box/glyph element in existing styling
 * solution via component model (so no inline styles to override).
 */
export const CheckboxGlyphStyles: React.FC<CheckboxGlyphStylesProps> = ({
  borderColor,
}) => (
  <style>
    {`
        ${selector} {
          border-color:${borderColor};
        }
      `}
  </style>
);
